import { observer } from "mobx-react";
import * as React from "react";
import { BrowserRouter, Redirect, Route, RouteComponentProps, RouteProps, Switch } from "react-router-dom";
// Source
import { store as uiStore } from "./store/ui";
import { store } from "./store";
import * as HelperSrc from "./HelperSrc";
import { updateUserAccess } from "./actions/login";
import { adInit, adResetStatus } from "./actions/adLogin";
import { PopupAlert } from "./components/molecules/PopupAlert";
import { DownloadPopup } from "./components/molecules/DownloadPopup";
import { Grad, GradHolder, PageRoot } from "./components/CustomTemplate";
import { LoginPage } from "./components/pages/LoginPage";
import { AdminClientsPage } from "./components/pages/AdminClientsPage";
import { AdminUsersPage } from "./components/pages/AdminUsersPage";
import { ClientsPage } from "./components/pages/ClientsPage";
import { LogsPage } from "./components/pages/LogsPage";
import { NotFoundPage } from "./components/pages/NotFoundPage";
import { ProfilePage } from "./components/pages/ProfilePage";
import { WorkbookFilesPage } from "./components/pages/WorkbookFilesPage";
import { WorkbookPage } from "./components/pages/WorkbookPage";
import { WorkbooksPage } from "./components/pages/WorkbooksPage";
import { LogoutPage } from "./components/pages/LogoutPage";
import { lang } from "./lang";

@observer
class Router extends React.Component {
    async componentDidMount() {
        uiStore.setLoaded(false);

        await updateUserAccess();

        const adInitStatus = localStorage.getItem(`${HelperSrc.LABEL}_ad_init_status`);

        if (adInitStatus) {
            await adInit();
        } else {
            const adWorkingStatus = localStorage.getItem(`${HelperSrc.LABEL}_ad_working_status`);

            if (uiStore.activeDirectoryReady && !adWorkingStatus) {
                adResetStatus();
            }
        }
    }

    public checkUserRole() {
        let result = HelperSrc.ROUTE_TYPE.WORKBOOKS;

        if (!store.user.id) {
            result = HelperSrc.ROUTE_TYPE.LOGIN;
        } else {
            if (store.user.is_superuser) {
                result = HelperSrc.ROUTE_TYPE.ADMIN_PROFILE;
            } else {
                result = HelperSrc.ROUTE_TYPE.CLIENTS;
            }
        }

        return result;
    }

    public render() {
        const redirectTo = this.checkUserRole();

        HelperSrc.checkSessionTimeout(store.user);

        return (
            <BrowserRouter getUserConfirmation={HelperSrc.confirmPageChange} basename={HelperSrc.URL_ROOT}>
                <Switch>
                    <Route
                        exact
                        key={HelperSrc.ROUTE_TYPE.HOME}
                        path={HelperSrc.ROUTE_TYPE.HOME}
                        render={() => {
                            return <Redirect to={redirectTo} />;
                        }}
                    />
                    <Route
                        exact
                        key={HelperSrc.ROUTE_TYPE.LOGIN}
                        path={HelperSrc.ROUTE_TYPE.LOGIN}
                        render={(e) => {
                            return (
                                <PageRoot>
                                    <GradHolder>
                                        <Grad />
                                    </GradHolder>
                                    <LoginPage {...e} appName={lang.appName} />
                                </PageRoot>
                            );
                        }}
                    />
                    <Route
                        exact
                        key={HelperSrc.ROUTE_TYPE.LOGOUT}
                        path={HelperSrc.ROUTE_TYPE.LOGOUT}
                        render={(props: RouteComponentProps) => {
                            return <LogoutPage {...props} />;
                        }}
                    />
                    <Route
                        key={HelperSrc.ROUTE_TYPE.HOME}
                        path={HelperSrc.ROUTE_TYPE.HOME}
                        render={() => {
                            const html: JSX.Element[] = [];

                            if (store.user.id) {
                                html.push(
                                    <Switch key="general-route">
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.CLIENTS}
                                            path={HelperSrc.ROUTE_TYPE.CLIENTS}
                                            render={(props: RouteComponentProps) => {
                                                return <ClientsPage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.PROFILE}
                                            path={HelperSrc.ROUTE_TYPE.PROFILE}
                                            render={(props: RouteComponentProps) => {
                                                return <ProfilePage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.LOGS}
                                            path={HelperSrc.ROUTE_TYPE.LOGS}
                                            render={(props: RouteComponentProps) => {
                                                return <LogsPage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.WORKBOOKS}
                                            path={HelperSrc.ROUTE_TYPE.WORKBOOKS}
                                            render={(props: RouteComponentProps) => {
                                                return <WorkbooksPage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.WORKBOOK_ID}
                                            path={HelperSrc.ROUTE_TYPE.WORKBOOK_ID}
                                            render={(props: RouteComponentProps) => {
                                                return <WorkbookPage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.WORKBOOK_FILES}
                                            path={HelperSrc.ROUTE_TYPE.WORKBOOK_FILES}
                                            render={(props: RouteComponentProps) => {
                                                return <WorkbookFilesPage {...props} />;
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.ADMIN}
                                            path={HelperSrc.ROUTE_TYPE.ADMIN}
                                            render={(props: RouteProps) => {
                                                if (store.user.is_superuser || store.user.is_support) {
                                                    return <AdminUsersPage {...props} />;
                                                } else {
                                                    <NotFoundPage {...props} />;
                                                }
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.ADMIN_PROFILE}
                                            path={HelperSrc.ROUTE_TYPE.ADMIN_PROFILE}
                                            render={(props: RouteProps) => {
                                                if (store.user.is_superuser) {
                                                    return <ProfilePage {...props} />;
                                                } else {
                                                    <NotFoundPage {...props} />;
                                                }
                                            }}
                                        />
                                        <Route
                                            exact
                                            key={HelperSrc.ROUTE_TYPE.ADMIN_CLIENTS}
                                            path={HelperSrc.ROUTE_TYPE.ADMIN_CLIENTS}
                                            render={(props: RouteProps) => {
                                                if (store.user.is_superuser) {
                                                    return <AdminClientsPage {...props} />;
                                                } else {
                                                    <NotFoundPage {...props} />;
                                                }
                                            }}
                                        />
                                        <Route path="*" key="*" render={(props: RouteProps) => <NotFoundPage {...props} />} />
                                    </Switch>
                                );
                            } else {
                                html.push(<Redirect key="redirect-login" to={HelperSrc.ROUTE_TYPE.LOGIN} />);
                            }
                            return html;
                        }}
                    />
                </Switch>
                <div
                    className="notice_box"
                    id="noticebox"
                    data-at_id="notice_box"
                    style={{
                        right: store.showNotice ? "20px" : "-320px"
                    }}
                >
                    <p>{store.notice.message}</p>
                    {(() => {
                        const html: JSX.Element[] = [];

                        for (const file of store.notice.fileList) {
                            html.push(<p>- {file}</p>);
                        }

                        return html;
                    })()}
                </div>
                <DownloadPopup />

                {store.alert.message !== "" && <PopupAlert />}
            </BrowserRouter>
        );
    }
}

export default Router;
